import Box from "@/common/components/Box";
import ResumeItem from "@/common/components/ResumeItem";
import { cn } from "@/common/utils/cn";
import {
  MaintenanceForwardingSectionStyle,
  maintenanceForwardingSectionStyles,
} from "@/features/maintenanceWorkflow/pages/Show/features/forwardings/constants/maintenanceForwardingSectionStyles.constant";
import { MaintenanceWorkflowData } from "@/features/maintenanceWorkflow/types/maintenanceWorkflows.type";
import { useMemo } from "react";
import MaintenanceWorkflowSolicitations from "./components/MaintenanceWorkflowSolicitations";

interface MaintenanceDescriptionProps {
  workflow: MaintenanceWorkflowData | undefined;
}

const MaintenanceDescription = ({ workflow }: MaintenanceDescriptionProps) => {
  const sectionStyle = useMemo(() => {
    if (workflow?.status === 'completed') {
      return maintenanceForwardingSectionStyles[MaintenanceForwardingSectionStyle.Completed];
    }

    if (workflow?.can_create_new_forwarding) {
      return maintenanceForwardingSectionStyles[MaintenanceForwardingSectionStyle.Pending];
    }

    return maintenanceForwardingSectionStyles[MaintenanceForwardingSectionStyle.Waiting];
  }, [workflow?.status, workflow?.can_create_new_forwarding]);

  return (
    <Box className={cn('p-4 flex flex-col gap-4 max-h-[calc(100vh-12rem)] overflow-auto', sectionStyle)}>
      <div className="flex flex-col gap-2">
        <div className="flex items-center justify-between">
          <p>
            Solicitações de manutenção
          </p>

          {workflow?.can_create_new_forwarding && (
            <p className="text-warning">
              Aguardando encaminhar processo
            </p>
          )}
        </div>

        <ResumeItem
          label="Descrição geral do processo"
          value={workflow?.observations || '--'}
          isLoading={!workflow}
          labelClassName="text-xs"
          valueClassName="text-sm"
        />
      </div>

      <MaintenanceWorkflowSolicitations />
    </Box>
  );
}

export default MaintenanceDescription;
